import ATS from '@elem/compPage/ATS';
import { GetServerSidePropsContext } from 'next';
import { useRouter } from 'next/router';
import { redirectTo404 } from '@/utils/redirect404';
import { useLang } from '@/i18n';
import SEOlinksA from '@/components/SEOlinksA';
import PageLayout from '@/components/PageLayout';
import { pathname, theme, sites } from '@elem/compPage/ATS/config/page';
import { ProductProvider, useProductMsg } from '@elem/compPage/ATS/ProductProvider';
import { initalState } from '@elem/compPage/ATS/context/initalState';
import dynamic from 'next/dynamic';

export default function Page({ SEO, pageStatus }: any) {
    const { locale = '' } = useRouter();
    const { t } = useLang('ats');
    const productMsg = useProductMsg();
    const GtmPageLoad = dynamic(() => import('@/components/GtmPageLoad'), { ssr: false });

    return (
        <PageLayout isNoFixed={true} theme={theme}>
            <SEO title={productMsg?.title || t('seo_title')} description={productMsg?.description || t('seo_desc')} />
            <SEOlinksA locale={locale} list={sites} pathname={pathname} />
            <GtmPageLoad />
            <ProductProvider children={<ATS />} pageStatus={pageStatus} />
        </PageLayout>
    );
}

// perf 性能优化, 静态html(如上) > getStaticProps > getServerSideProps（如下）
export async function getServerSideProps({ locale = 'us', query }: GetServerSidePropsContext) {
    if (!sites.includes(locale)) {
        return redirectTo404();
    }
    const _timer = query?._timer ? String(query?._timer) : undefined;
    const props = initalState(locale, _timer);
    if (props === '404') {
        return redirectTo404();
    }
    return {
        props,
    };
}
